var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondividi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 60C47.4 60.2 45 60.2 42.6 60.6C39.2 61.2 35.8 61.8 32.5 62.9C26.2 65 21.8 69.5 18.8 75.3C18.2 76.5 17.6 77.6 17 78.8C16.4 79.9 15.4 80.3 14.3 80.1C13.1 79.8 12.4 79 12.3 77.8C12.2 70.3 12.5 62.8 14.6 55.5C17.5 45.8 24.2 40 33.7 37.2C38.5 35.8 43.5 35.3 48.4 35C48.8 35 49.2 35 49.8 34.9C49.8 34.4 49.8 34 49.8 33.5C49.8 28.3 49.8 23.1 49.8 17.9C49.8 16.6 50.1 15.6 51.3 15C52.6 14.4 53.5 15 54.5 15.8C65 25.6 75.6 35.3 86.1 45C87.9 46.7 87.9 48 86.1 49.7C75.6 59.4 65.1 69.1 54.5 78.8C53.6 79.6 52.7 80.2 51.5 79.8C50.3 79.4 49.8 78.5 49.8 76.9C49.8 71.7 49.8 66.5 49.8 61.3C50 61.1 50 60.7 50 60ZM55 71.9C64 63.6 72.7 55.6 81.4 47.5C72.6 39.4 63.9 31.3 55 23.1C55 27.9 55 32.4 55 36.9C55 39.1 54.1 39.9 52 40C47.9 40.3 43.8 40.5 39.8 41C35.2 41.6 30.9 43.1 27.1 45.8C19.8 51.1 18.4 59.1 17.6 67.5C17.9 67.2 18.1 67.1 18.2 66.9C21.6 62.6 26 59.7 31.1 57.9C37.8 55.5 44.7 54.9 51.7 54.9C54.1 54.9 54.9 55.7 54.9 58.2C55 62.7 55 67.1 55 71.9Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondividi);
export default __webpack_public_path__ + "static/media/condividi.889682700d3cd2c8e96e4b055e158dab.svg";
export { ForwardRef as ReactComponent };